<div class="card">
  <div class="card-header">
    <div class="d-flex flex-wrap justify-content-between align-items-center w-100">
      <h3 class="fw-bold my-2">{{ 'companyProfile.deals.title' | translate }}</h3>
      <app-button
        [variant]="'primary'"
        [label]="'companyProfile.deals.addDeal' | translate"
        [iconClass]="'fa fa-plus'"
        (clicked)="openAddModal()"
      />
    </div>
  </div>
  <div class="card-body">
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center py-10">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
        </div>
      </div>
    } @else if (deals.length === 0) {
      <div class="text-center py-15">
        <i class="fa fa-tag fs-3x text-muted mb-5"></i>
        <h4 class="text-muted">{{ 'companyProfile.deals.noDeals' | translate }}</h4>
        <p class="text-muted mb-5">{{ 'companyProfile.deals.noDealsHint' | translate }}</p>
        <app-button
          [label]="'companyProfile.deals.addDeal' | translate"
          [variant]="'primary'"
          [iconClass]="'fa fa-plus'"
          (clicked)="openAddModal()"
        />
      </div>
    } @else {
      <div class="row g-6 g-xl-9">
        @for (deal of deals; track deal.deal_id) {
          <div class="col-md-6 col-lg-4">
            <div class="deal-card card h-100">
              <div class="deal-image-container">
                @if (deal.image_url) {
                  <img [src]="deal.image_url" alt="Deal Image" class="deal-image" />
                } @else {
                  <div class="deal-image-placeholder">
                    <i class="fa fa-tag fs-2x"></i>
                  </div>
                }
                @if (deal.discount_percentage) {
                  <div class="discount-badge">
                    {{ deal.discount_percentage }}% OFF
                  </div>
                }
                @if (isDealActive(deal)) {
                  <div class="status-badge active">{{ 'companyProfile.deals.active' | translate }}</div>
                } @else if (isDealExpired(deal)) {
                  <div class="status-badge expired">{{ 'companyProfile.deals.expired' | translate }}</div>
                } @else if (isDealUpcoming(deal)) {
                  <div class="status-badge upcoming">{{ 'companyProfile.deals.upcoming' | translate }}</div>
                }
              </div>
              <div class="card-body">
                <h5 class="deal-title mb-2">{{ deal.title }}</h5>
                @if (deal.description) {
                  <p class="deal-description text-muted mb-2">{{ deal.description }}</p>
                }
                <div class="deal-dates text-muted small mb-2">
                  <i class="fa fa-calendar me-1"></i>
                  {{ deal.start_date | date:'mediumDate' }} - {{ deal.end_date | date:'mediumDate' }}
                </div>
                <div class="discount-code-section">
                  <span class="text-muted small">{{ 'companyProfile.deals.discountCode' | translate }}:</span>
                  <code class="discount-code ms-2">{{ deal.discount_code }}</code>
                </div>
              </div>
              <div class="card-footer bg-transparent border-top-0">
                <div class="d-flex justify-content-center gap-2">
                  <app-button
                    [variant]="'ghost'"
                    [iconClass]="'fa fa-edit'"
                    [size]="'sm'"
                    (clicked)="openEditModal(deal)"
                  />
                  <app-button
                    [variant]="'ghost'"
                    [iconClass]="'fa fa-trash text-danger'"
                    [size]="'sm'"
                    (clicked)="deleteDeal(deal)"
                  />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>
